import { render, staticRenderFns } from "./transLang.vue?vue&type=template&id=58d5d28b&scoped=true"
import script from "./transLang.vue?vue&type=script&lang=js"
export * from "./transLang.vue?vue&type=script&lang=js"
import style0 from "./transLang.vue?vue&type=style&index=0&id=58d5d28b&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d5d28b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58d5d28b')) {
      api.createRecord('58d5d28b', component.options)
    } else {
      api.reload('58d5d28b', component.options)
    }
    module.hot.accept("./transLang.vue?vue&type=template&id=58d5d28b&scoped=true", function () {
      api.rerender('58d5d28b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/head/transLang.vue"
export default component.exports